module.exports = __webpack_public_path__ + "static/media/al4.decc3738.mp4";